<template>
  <div id="CustodyIndex">
    <a-Card
      :tabList="tabList"
      @tabChange="key => onTabChange(key, 'key')"
      class="cardStyle"
    >
      <keep-alive>
        <router-view></router-view>
      </keep-alive> 
    </a-Card> 
  </div>
</template>
<script>
import { Card } from 'ant-design-vue'
export default {
  name:"CustodyIndex",
  data(){
    return{
      tabList:[
        {
          key:"/custody",
          tab:"家长监护工程说明"
        },{
          key:"/custody/applyReg",
          tab:"申请流程"
        },{
          key:"/custody/applyNotice",
          tab:"申请须知"
        },{
          key:"/custody/Question",
          tab:"常见问题"
        },{
          key:"downLoad",
          tab:"申请表下载"
        } 
      ]
    }
  },
  methods: {
    onTabChange(key){
      if(key!=="downLoad"){
        this.$router.push(key);
      }else{ 
        try{
          window.open( "https://www.racoondigi.cn/lyty.zip")
        }catch(err){
          console.log(err);
          const downloadLink = document.createElement('a');
          const body = document.documentElement || document.body;
          body.appendChild(downloadLink);
          downloadLink.href = "https://www.racoondigi.cn/lyty.zip"
          downloadLink.download = true; 
          downloadLink.click();
          body.removeChild(downloadLink);
        }
      }
    }
  },
  components:{
    aCard:Card
  }
}
</script>
<style lang="stylus" scoped>
@import "../Common/common.styl"
.cardStyle{
  cardStyle();
}
</style>



// WEBPACK FOOTER //
// src/components/Custody/Custody.vue